import { TopViewSection } from './TopViewSection'
import { withTopViewSection } from './withTopViewSection'

const ConnectedTopViewSection = withTopViewSection(TopViewSection)
export { ConnectedTopViewSection as TopViewSection }
